<rt-button
  #sortByButtonDropdownTrigger="rtOverlayOrigin"
  [variant]="variant()"
  [disabled]="disabled()"
  rt-overlay-origin
  [dropdownOpened]="state.dropdownOpen"
  [dropdownVisible]="!noButtonLabel()"
  [class.with-select-button-style]="withSelectButtonStyle()"
  (click)="toggleDropdown(!state.dropdownOpen)"
>
  @if (value) {
    <div layout-horizontal layout-align-items-center layout-full-width>
      <rt-icon [name]="getIcon(value.direction)" margin-right-small-x />
      @if (!noButtonLabel()) {
        <div class="label-content" [innerHTML]="getValueLabel(value.columnId)"></div>
      }
    </div>
  }
  @if (!value) {
    {{ 'app.common.sort_by' | translate }}
  }
</rt-button>

<ng-template
  #reportSortByDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="sortByButtonDropdownTrigger"
  [minWidth]="sortByButtonDropdownTrigger.elementRef.nativeElement.clientWidth"
  [open]="state.dropdownOpen"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-dropdown
    class="dropdown"
    [class.with-scroll]="dropdownWithScroll()"
    [class.with-select-button-style]="withSelectButtonStyle()"
    [width]="dropdownWidth"
  >
    @if (dropdownHeader) {
      <rt-dropdown-header [fullWidthTitle]="true">
        {{ dropdownHeader }}
      </rt-dropdown-header>
    }
    @if (allowReset()) {
      <rt-dropdown-item (click)="handleResetClick()">
        {{ 'app.common.none' | translate }}
      </rt-dropdown-item>
    }
    @for (option of options(); track trackByColumnId($index, option)) {
      <rt-dropdown-item (click)="handleOptionClick(option)">
        <div layout layout-align-items-center>
          <span [innerHTML]="option.label"></span>
          @if (option.isNew) {
            <rt-badge
              color="pink-gradient"
              [text]="'app.common.new' | translate"
              margin-left-small-x
            />
          }
        </div>
        @if (value && option.columnId === value.columnId) {
          <rt-icon
            suffix
            #symbol
            [name]="getIcon(value.direction)"
            colorToken="colorIconPrimaryDefault"
          />
        }
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
